"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectContactData.name': 'Contact Data Detection',
    'tools.detectContactData.description': 'Automatically detect and extract contact information like phone numbers, emails, addresses, and names from user messages',
};
